import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserRocketRepairGame from 'src/games/RocketRepairGame/Main';
import { message } from 'antd';

// Note: RouteComponentProps<{}> MUST be removed if sub-component OR MUST return 'withRouter(RocketRepairGame)'
interface RocketRepairGameProps extends RouteComponentProps<{}> {
    onComplete?: () => void;
}

interface RocketRepairGameState {
}

class RocketRepairGame extends React.Component<RocketRepairGameProps, RocketRepairGameState> {
    constructor(props: RocketRepairGameProps) {
        super(props);
        bindAllOfThis(this, RocketRepairGame.prototype);

        // You are allowed to set defaults here, based on your state object above
        this.state = {
        };
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserRocketRepairGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default RocketRepairGame;



// WEBPACK FOOTER //
// ./src/pages/game/RocketRepairGame.tsx